import {
    Select,
    FormControl,
    InputLabel,
    FormLabel,
    CircularProgress,
    TextField,
    ExpansionPanelSummary,
} from "@material-ui/core";
import { PRIMARY_COLOR } from "src/constants/color";
import styled from "styled-components";
import { FormCommonStyle } from "./css";
import { ERROR_COLOR } from "../constants/color";

export const StyledSelect: any = styled(Select)`
  && {
    width: 100%;
    // font-size: 14px;
    // margin-top: 18px;
    // font-weight: bold;
    // color: #333 !important;
  }
`;

export const StyledFormControl: any = styled(FormControl)`
  && {
    width: 100%;
    display: block;
    position: relative;
  }
`;

export const StyledInputLabel: any = styled(InputLabel)`
  && {
    padding-left: 5px;
    .req-label {
      color: #cc0000;
    }
  }
`;

export const StyledAutoSelectInputLabel: any = styled(InputLabel)`
  && {
    padding-left: 5px;
    .req-label {
      color: #cc0000;
    }
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
`;

export const DropzoneContainer = styled.div`
  position: relative;
  > div {
    width: 100% !important;
    height: 60px !important;
    border-width: 1px !important;
    border-style: dotted !important;
    margin: 10px 0;
  }
  .dz-title {
    align-items: center;
    display: flex;
    font-size: 14px;
    height: 100%;
    justify-content: center;
    strong {
      padding: 0 4px;
    }
  }
`;

export const StyledFormLabel: any = styled(FormLabel)`
  && {
    font-size: 14px;
    .req-label {
      color: #cc0000;
    }
  }
`;

export const FieldProgress: any = styled(CircularProgress)`
  && {
    position: absolute;
    top: ${(props: any) => (props.isContact ? "none" : "50px")};
    right: ${(props: any) => (props.isContact ? "20px" : "20px")};
    z-index: 11;
    color: #1c3342;
    bottom: ${(props: any) => (props.isContact ? "20px" : 0)};
  }
`;

export const FieldProgressDelete: any = styled(CircularProgress)`
  && {
    position: absolute;
    top: 18px;
    right: 10px;
    z-index: 11;
    color: #1c3342;
    bottom: 0;
  }
`;

export const StyledTextField: any = styled(TextField)`
  && {
    width: 100%;
    ${FormCommonStyle}
    input {
      color: #333;
      border: 0;
      padding: 6px 0 7px;
      background-color: transparent;
    }
    textarea {
      height: ${(props: any) => (props.multiline ? props.height : "auto")};
      resize: vertical;
    }
    .autoselect-material {
      display: flex;
      z-index: 0;
      height: auto !important;
      padding: 0;
      > div {
        padding: 0;
        margin-top: 10px;
        > div {
          font-weight: normal;
          margin: 5px 5px 0 0;
          border-radius: 12px;
          padding: 0px 2px
          max-width: ${(props: any) =>
        props.setwidth === "Consignee" ? "250px" : "none"};
          div + div:hover {
            background-color: transparent;
            cursor: pointer;
          }

          div + div svg {
            background: rgba(0, 0, 0, 0.26);
            border-radius: 50%;
            padding: 1px;
            color: #fff;
            :hover {
              background-color: rgba(0, 0, 0, 0.4);
            }
          }
          > div {
            font-weight: bold;
          }
        }
      }
      // option, options {
      //     z-index: 99999;
      // }
    }
  }
`;

export const StyledExpansionPanelSummary: any = styled(ExpansionPanelSummary)`
  && {
    background: ${(props: any) =>
        props.isPoNoError || props.isPoItemNoError ? "#cc0000" : PRIMARY_COLOR};
    display: flex,
    align-items: center,
  }
`;

export const FormError = styled.div`
  color: ${ERROR_COLOR};
  font-size: 14px;
  padding-top: 2px;
  position: absolute;
  right: 5px;
`;

export const stylesReactSelect = {
    clearIndicator: (provided: any, state: any) => ({
        ...provided,
        cursor: "pointer",
    }),
    indicatorSeparator: (provided: any, state: any) => ({
        ...provided,
        margin: 0,
    }),
    dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        cursor: "pointer",
    }),
    placeholder: (provided: any, state: any) => ({       
        ...provided,
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        color: state.selectProps.error ? "#f44336" : "rgba(0, 0, 0, 0.54)",
    }),
    control: (provided: any, state: any) => ({
        ...provided,       
        borderRadius: 0,
        border: 0,
        borderBottom: state.selectProps.error
            ? "1px solid #f44336"
            : "1px solid rgba(0,0,0,0.87)",
        boxShadow: "none",
        ":hover": {
            borderColor: state.selectProps.error ? "1px solid #f44336" : "inherit",
            boxShadow: state.selectProps.error ? "1px solid #f44336" : "none",
        },
        backgroundColor: "none",
        width: "100%",
    }),
    container: (provided: any, state: any) => ({
        ...provided,
        width:"100%"
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        paddingLeft: 0,
    }),
};
